import "./Policies.css"

export default function Policies(){

    return(
        <main>
            
            <div className='outerBox'>

                <h1>Co-op Policies</h1>
                
                <div className="policyInnerBox">
                    
                    <div class="link-grid">
                        <a href="https://drive.google.com/file/d/1k0YIMg3fKg5QRym2-tJS4Xi4-LlbeAcj/view?usp=drive_link" 
                            alt="Policy1" target="_blank" rel="noreferrer">
                            Access to Information Policy
                        </a>

                        <a href="https://drive.google.com/file/d/16BF5KDCZT-YbJgma_ZLgzx2FPMNkkDBq/view?usp=drive_link" 
                            alt="Policy2" target="_blank" rel="noreferrer">
                            Babysitting Expenses
                        </a>

                        <a href="https://drive.google.com/file/d/1cI4r0bkYAs-5c357cddRvSwdGjEQoxaj/view?usp=drive_link" 
                            alt="Policy3" target="_blank" rel="noreferrer">
                            Board of Directors Code of Conduct & Protocols
                        </a>

                        <a href="https://drive.google.com/file/d/1XGw5qzhoWfH4i3JfijZZO5j_takVlGiq/view?usp=drive_link" 
                            alt="Policy4" target="_blank" rel="noreferrer">
                            Decorating & Housekeeping Policy
                        </a>

                        <a href="https://drive.google.com/file/d/17mFeZGHouOd1b1se_OkdWIULhJ9fDXhi/view?usp=drive_link" 
                            alt="Policy5" target="_blank" rel="noreferrer">
                            Fraud/Dishonest Activities Policy
                        </a>

                        <a href="https://drive.google.com/file/d/1L_gslis_O6pfN4rCOM8uQPvcRA4tYH1B/view?usp=drive_link" 
                            alt="Policy6" target="_blank" rel="noreferrer">
                            Internal Waiting List
                        </a>

                        <a href="https://drive.google.com/file/d/1EDY2fM8rRiDvfiNavoGz48FNnDNNXg1T/view?usp=drive_link" 
                            alt="Policy7" target="_blank" rel="noreferrer">
                            Key & Access Policy
                        </a>

                        <a href="https://drive.google.com/file/d/1Qc07b3o0_ppaeLbL1uUlsfIXREKYtt4N/view?usp=drive_link" 
                            alt="Policy8" target="_blank" rel="noreferrer">
                            Member Participation Policy
                        </a>

                        <a href="https://drive.google.com/file/d/1DsClZV0eLje619DpjM7d8D-iidDo4rFW/view?usp=drive_link" 
                            alt="Policy9" target="_blank" rel="noreferrer">
                            Modern Investment Policy
                        </a>

                        <a href="https://drive.google.com/file/d/1m52CQ8fnyvn9EDfZAGK-7k8xpShBnFOD/view?usp=drive_link" 
                            alt="Policy10" target="_blank" rel="noreferrer">
                            Modern Investment Policy
                        </a>

                    </div>

                </div>
            </div>

        </main>

    )
}